import InputMask from "react-input-mask"
import { Controller } from "react-hook-form"
import Label from "./Label"
import Fieldset from "./Fieldset"

import {
  branchNumber,
  accountNumber,
  operatorCode,
  creditCard,
  cpf,
} from "../../utils/maskers"

import { validateCpf } from "../../utils/validate"

export const Branch = ({ register, control }) => {
  return (
    <Fieldset>
      <Label forHtml="branch" name="Agência">
        <Controller
          name="branch"
          control={control}
          defaultValue=""
          {...register("branch", {
            required: true,
            minLength: 4,
          })}
          ref={null}
          render={({ field: { onChange, value } }) => (
            <InputMask
              mask={branchNumber}
              maskChar=""
              value={value}
              onChange={onChange}
            >
              <input
                className="ds-header__form-input-login ds-header__form-input-login--branch"
                placeholder="agência"
                autoComplete="off"
                aria-required="true"
                type="tel"
                id="branch"
              />
            </InputMask>
          )}
        />
      </Label>
      <span className="ds-header__form-spacer-input"></span>
      <Label forHtml="account" name="Conta">
        <Controller
          name="account"
          control={control}
          defaultValue=""
          {...register("account", { required: true, minLength: 7 })}
          ref={null}
          render={({ field: { onChange, value } }) => (
            <InputMask
              mask={accountNumber}
              maskChar=""
              value={value}
              onChange={onChange}
            >
              <input
                className="ds-header__form-input-login ds-header__form-input-login--account"
                placeholder="conta"
                autoComplete="off"
                aria-required="true"
                type="tel"
                id="account"
              />
            </InputMask>
          )}
        />
      </Label>
    </Fieldset>
  )
}

export const Operator = ({ register, control }) => {
  return (
    <Fieldset>
      <Label forHtml="operatorCode" name="Código do operador" classes="-operatorCode">
        <Controller
          name="operatorCode"
          control={control}
          defaultValue=""
          {...register("operatorCode", {
            required: true,
            minLength: 9,
          })}
          ref={null}
          render={({ field: { onChange, value } }) => (
            <InputMask
              mask={operatorCode}
              maskChar=""
              value={value}
              onChange={onChange}
            >
              <input
                className="ds-header__form-input-login"
                aria-describedby="description_operatorCode"
                placeholder="código do operador"
                autoComplete="off"
                aria-required="true"
                type="tel"
                id="operatorCode"
              />
            </InputMask>
          )}
        />
      </Label>
    </Fieldset>
  )
}

export const CreditCard = ({ register, control }) => {
  return (
    <Fieldset>
      <Label forHtml="creditCard" classes="-creditCard">
        <Controller
          name="creditCard"
          control={control}
          defaultValue=""
          ref={register("creditCard", {
            required: true,
            minLength: 19,
          })}
          ref={null}
          render={({ field: { onChange, value } }) => (
            <InputMask
              mask={creditCard}
              maskChar=""
              value={value}
              onChange={onChange}
            >
              <input
                className="ds-header__form-input-login"
                aria-describedby="description_creditCard"
                placeholder="cartao de crédito"
                autoComplete="off"
                aria-required="true"
                type="tel"
                id="creditCard"
              />
            </InputMask>
          )}
        />
      </Label>
    </Fieldset>
  )
}

export const Cpf = ({ register, control }) => {
  return (
    <Fieldset>
      <Label forHtml="documentNumber" name="CPF" classes="-documentNumber">
        <Controller
          name="documentNumber"
          control={control}
          defaultValue=""
          ref={register("documentNumber", {
            required: true,
            minLength: 14,
            validate: validateCpf,
          })}
          ref={null}
          render={({ field: { onChange, value } }) => (
            <InputMask mask={cpf} maskChar="" value={value} onChange={onChange}>
              <input
                className="ds-header__form-input-login"
                aria-describedby="description_documentNumber"
                placeholder="CPF"
                autoComplete="off"
                aria-required="true"
                type="tel"
                id="documentNumber"
              />
            </InputMask>
          )}
        />
      </Label>
    </Fieldset>
  )
}
